import { useEffect, useState } from "react"
import { getCandidateTerms, patchCandidateTerm } from "@/api/candidate/candidateTerms"
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Loader } from "@/components/ui/loader"
import { CheckCircle } from "lucide-react"
import {BackButton} from "@/components/ui/BackButton.jsx";

export default function AgreementsPage() {
    const [terms, setTerms] = useState([])
    const [loading, setLoading] = useState(true)
    const [selectedTerm, setSelectedTerm] = useState(null)
    const [dialogOpen, setDialogOpen] = useState(false)

    useEffect(() => {
        async function load() {
            try {
                const res = await getCandidateTerms()
                console.log(res)
                setTerms(res)
            } catch (err) {
                console.error("Failed to load terms", err)
            } finally {
                setLoading(false)
            }
        }
        load()
    }, [])

    const handleView = (term) => {
        if (term.termType === 'text') {
            setSelectedTerm(term)
            setDialogOpen(true)
        } else if (term.termType === 'file') {
            window.open(term.fileUrl, "_blank")
        }
    }

    const handleAgree = async (termId) => {
        const confirmed = window.confirm("Are you sure you agree to these terms?")
        if (!confirmed) return

        try {
            await patchCandidateTerm(termId)
            setTerms(prev => prev.map(t =>
                t.id === termId
                    ? { ...t, candidateTerm: { agreed: true } }
                    : t
            ))
            if (selectedTerm?.id === termId) {
                setSelectedTerm(prev => ({ ...prev, candidateTerm: { agreed: true } }))
                setDialogOpen(false)
            }
        } catch (err) {
            console.error("Failed to agree to term", err)
            alert("Could not update agreement. Please try again.")
        }
    }

    if (loading) return <Loader />

    return (
        <div className="space-y-6  p-3 bg-brand-25">
            <BackButton to="/profile/candidate" />
            <h1 className="text-xl font-bold">Agreements</h1>

            {terms.map(term => (
                <Card key={term.id} className="p-4 space-y-3">
                    <div className="flex justify-between items-center">
                        <h2 className="font-semibold text-lg">{term.name}</h2>
                        <Button variant="outline" size="sm" onClick={() => handleView(term)}>
                            {term.termType === 'file' ? "Download" : "View"}
                        </Button>
                    </div>

                    {term.candidateTerm?.agreed ? (
                        <div className="flex items-center gap-2 text-green-600">
                            <CheckCircle className="w-5 h-5" />
                            <span>You have agreed to these terms</span>
                        </div>
                    ) : (
                        <Button className={"bg-brand-500"} size="sm" onClick={() => handleAgree(term.id)}>
                            I agree to these terms
                        </Button>
                    )}
                </Card>
            ))}

            <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>{selectedTerm?.name}</DialogTitle>
                    </DialogHeader>
                    <div className="whitespace-pre-line text-sm pt-2">
                        {selectedTerm?.copy}
                    </div>
                    {!selectedTerm?.candidateTerm?.agreed && (
                        <div className="pt-4">
                            <Button onClick={() => handleAgree(selectedTerm.id)}>
                                I agree to these terms
                            </Button>
                        </div>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    )
}
